export default {
  width100: {
    width: "100%",
  },
  flex: {
    display: "flex",
  },
  flexRow: {
    flexDirection: "row",
  },
  flexColumn: {
    flexDirection: "column",
  },
  flexCenter: {
    alignItems: "center",
  },
  marginT5: {
    marginTop: 5
  },
  marginT8: {
    marginTop: 8
  },
  marginT10: {
    marginTop: 10
  },
  marginT16: {
    marginTop: 16
  },
  marginT20: {
    marginTop: 20
  },
  marginT30: {
    marginTop: 30
  },
  marginT40: {
    marginTop: 40
  },
  marginB5: {
    marginBottom: 5
  },
  marginB8: {
    marginBottom: 8
  },
  marginB10: {
    marginBottom: 10
  },
  marginB16: {
    marginBottom: 16
  },
  marginB20: {
    marginBottom: 20
  },
  marginB30: {
    marginBottom: 30
  },
  marginB40: {
    marginBottom: 40
  },
  marginL10: {
    marginLeft: 10
  },
  marginL20: {
    marginLeft: 20
  },
  marginR10: {
    marginRight: 10
  },
  marginR20: {
    marginRight: 20
  },
}
